import { render, staticRenderFns } from "./VocHome.vue?vue&type=template&id=82bc0cee&scoped=true"
import script from "./VocHome.vue?vue&type=script&lang=js"
export * from "./VocHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bc0cee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82bc0cee')) {
      api.createRecord('82bc0cee', component.options)
    } else {
      api.reload('82bc0cee', component.options)
    }
    module.hot.accept("./VocHome.vue?vue&type=template&id=82bc0cee&scoped=true", function () {
      api.rerender('82bc0cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/VocHome.vue"
export default component.exports